import $ from 'jquery';

export default class LoginPage {
    constructor(theme) {
        this.theme = theme;

        this.loadPasswordRecover();

        $("#forgot-password-box").on('click', function(){
            $("#customer-login").hide();
            $("#recover-password").show();
        });

        $("#login-box-link").on('click', function(){
            $("#customer-login").show();
            $("#recover-password").hide();
        });

        if (document.querySelector(".resetSuccessful")) {
            $('#resetSuccess').show();
        }
    }

    loadPasswordRecover = () => {
        var $recover = $('.recover-form');
        if ($recover.length === 0) {
            return;
        }
        $recover.removeClass('no-js');
        if (window.location.hash !== '#recover') {
            $recover.addClass('hide');
        }
        $('.show-password-form').on('click', function (e) {
            $recover.toggleClass('hide');
        });
    }
}
